module.exports = __webpack_public_path__ + "img/lingdaoxinxi-bg.2838dec5.png";